import mixpanel from "mixpanel-browser";
import { ADMIN, SUPER_ADMIN, TEACHER } from "../constants";
mixpanel.init("972878fce13f7a9fc66731f4f0b478ad", { debug: true });

let env_check = true;

let actions = {
	identify: (id) => {
		if (env_check) mixpanel.identify(id); //track unique id everywhere
	},
	track: (name, props) => {
		if (env_check) mixpanel.track(name, props); // track events   name="Register" props={"phNum": "123", "name": "Abc"}
	},
	people: {
		set: (props) => {
			if (env_check) mixpanel.people.set(props); // user profile info    props= {"type": "Guest"}
		},
		set_once: (props) => {
			if (env_check) mixpanel.people.set_once(props); // user profile info (only sets if property doesn't already exist)   props= {"type": "Guest"}
		},
		increment: (props) => {
			if (env_check) mixpanel.people.increment(props); // user profile info    props= {"Count": 1}
		},
	},
};

export let Mixpanel = actions;

export const getMixpanelAdminType = (group) => {
  if (group.includes(SUPER_ADMIN)) {
		return "SuperAdmin";
	}
	if (group.includes(ADMIN)) {
		return "Admin";
	}
	if (group.includes(TEACHER)) {
		return "Teacher";
	}
  return null;
};